import React from "react";
import TableRowComponent from "./TableRowComponent";

const TableComponent = ({component, path, index}) => {
    const {properties, children} = component;
    const columns = children[0]?.children || [];
    return (
        <table style={{borderCollapse: 'collapse', tableLayout: 'fixed', width: '100%', borderColor: 'red'}}>
            {children.map((tr, rowIndex) => (
                <TableRowComponent
                    component={tr}
                    path={path}
                    rowIndex={rowIndex}
                    columns={columns}
                />
            ))}
        </table>
    )
}

export default TableComponent



